import { useEffect, useLayoutEffect } from "react";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useQuery, useSubscription } from "@apollo/client";
import moment from "moment";
import { GET_CALL_COUNT } from "../../../graphql/query/query";
import { useAuth } from "../../../context/Auth.context";
import { useAppContext } from "../../../context/App.context";
import HocPopup from "../../../hoc/hocPopup";

import CardComponent from "./manager/card/Card.component";
import CustomersListComponent from "../insurance/CustomersList.component";
import InformationDialog from "../../base/dialog-body/Information.dialog";
import {
  TYPE,
  capitalizeFirstLetter,
  firstOfMonth,
  today,
} from "../../../utils/Utils";
import { HomeStyle } from "./Home.style";
import { CardStyle } from "./manager/card/Card.style";
import { useState } from "react";
import { ON_EMPLOYEE_UPDATE } from "../../../graphql/subscription/subscription";
import QRCodeDialog from "./dialog/dialogBody/QRCode.dialog";
import { LaunchOutlined, QrCode } from "@mui/icons-material";
import Theme from "../../../utils/Theme";
import { RiSendPlaneFill } from "react-icons/ri";
import ManagerComponent from "./manager/Manager.component";

const getDealershipCount = (app, filter) => {
  let sumOfTarget = app.target.reduce(
    (value, number) => value + number.assigned_target,
    0,
  );
  console.log("sumOfTarget", sumOfTarget);
  let sumOfCompleted = app.target.reduce(
    (value, number) => value + number.completed,
    0,
  );
  console.log("sumOfCompleted", sumOfCompleted);
  let perDay;
  let currentDay;
  let betweenDays = moment(moment(filter.d_endDate).format("YYYY-MM-DD")).diff(
    moment(moment(filter.d_startDate).format("YYYY-MM-DD")),
    "days",
  );

  if (moment(filter.d_startDate).month() === moment().month()) {
    perDay = sumOfTarget / moment().daysInMonth();
    currentDay = Math.round(moment().format("DD") * perDay);
  } else {
    perDay = sumOfTarget / betweenDays;
    currentDay = Math.round(betweenDays * perDay);
  }
  console.log("currentDay", currentDay);
  console.log("perDay", perDay);
  let percentage = currentDay
    ? Math.round((sumOfCompleted / currentDay) * 100)
    : 0;
  console.log("percentage", percentage);
  let sumOfQuotes = app.target.reduce(
    (value, number) => value + number.quotes_requested,
    0,
  );
  let percentageOfRequested = sumOfCompleted
    ? Math.round((sumOfQuotes / sumOfCompleted) * 100)
    : 0;

  let reviewsProvided = app?.target.reduce(
    (value, number) => value + number?.review_provided,
    0,
  );
  let satisfied_yes = app?.target.reduce(
    (value, number) => value + number?.satisfied_yes,
    0,
  );
  let satisfied_no = app?.target.reduce(
    (value, number) => value + number?.satisfied_no,
    0,
  );
  let referral_provided = app?.target.reduce(
    (value, number) => value + number?.referral_provided,
    0,
  );
  let apps_downloaded = app?.target.reduce(
    (value, number) => value + number?.apps_downloaded,
    0,
  );
  let appointment_set = app?.target.reduce(
    (value, number) => value + number?.appointment_set,
    0,
  );
  let watchedArtifacs = app?.target.reduce(
    (value, number) => value + number?.watched_artifacts,
    0,
  );

  // NEW: sum the four "(+value)" follow-up counts across every employee,
  // same reduce pattern used above for everything else on this card.
  let verified_followup = app?.target.reduce(
    (value, number) => value + (number?.verified_followup || 0),
    0,
  );
  let review_followup = app?.target.reduce(
    (value, number) => value + (number?.review_followup || 0),
    0,
  );
  let referral_followup = app?.target.reduce(
    (value, number) => value + (number?.referral_followup || 0),
    0,
  );
  let appointment_followup = app?.target.reduce(
    (value, number) => value + (number?.appointment_followup || 0),
    0,
  );

  // NEW: satisfied Y/N follow-up split (D = answer, F = second_review_answer)
  let satisfied_yes_followup = app?.target.reduce(
    (value, number) => value + (number?.satisfied_yes_followup || 0),
    0,
  );
  let satisfied_no_followup = app?.target.reduce(
    (value, number) => value + (number?.satisfied_no_followup || 0),
    0,
  );

  return {
    target: sumOfTarget,
    completed: sumOfCompleted,
    percentage: percentage || 0,
    quotesRequested: sumOfQuotes,
    percentageOfRequested: percentageOfRequested || 0,

    review_provided: reviewsProvided,
    satisfied_yes: satisfied_yes,
    satisfied_no: satisfied_no,
    referral_provided: referral_provided,
    apps_downloaded: apps_downloaded,
    appointment_set: appointment_set,
    watchedArtifacs: watchedArtifacs,
    // NEW
    verified_followup: verified_followup,
    review_followup: review_followup,
    referral_followup: referral_followup,
    appointment_followup: appointment_followup,
    // NEW
    satisfied_yes_followup: satisfied_yes_followup,
    satisfied_no_followup: satisfied_no_followup,
  };
};
const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const INITIAL_FILTER = {
  startDate: moment(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  ).format("MM/DD/YYYY"),
  endDate: moment(
    new Date().toLocaleString("en-US", {
      timeZone: userTimezone,
    }),
  ).format("MM/DD/YYYY"),
};

const HomeComponent = ({ dialog }) => {
  const auth = useAuth();
  const app = useAppContext();

  const [filterData, setFilterData] = useState(INITIAL_FILTER);
  const [fetchInput, setFetchInput] = useState({
    d_startDate: moment(filterData.startDate).format("YYYY-MM-DD"),
    d_endDate: moment(filterData.endDate).format("YYYY-MM-DD"),
    dealership_id: auth.user.dealership_id,
    timezone: new Date().getTimezoneOffset(),
    isAdmin: false,
  });
  const [checkService, setCheckService] = useState({
    insurance: true,
    knowledgeHub: false,
    prequal: false,
    idVerfication: false,
  });

  useEffect(() => {
    if (auth?.user?.dealershipServices?.length > 0) {
      console.log("serviceRunning");
      auth?.user?.dealershipServices?.forEach((item) => {
        if (item?.service_id === 1) {
          setCheckService((prev) => ({
            ...prev,
          }));
        } else if (item?.service_id === 2) {
          setCheckService((prev) => ({
            ...prev,
            knowledgeHub: true,
          }));
        } else if (item?.service_id === 3) {
          setCheckService((prev) => ({
            ...prev,
            prequal: true,
          }));
        } else if (item?.service_id === 4) {
          setCheckService((prev) => ({
            ...prev,
            idVerfication: true,
          }));
        }
      });
    }
  }, []);

  const { data, refetch } = useQuery(GET_CALL_COUNT, {
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    variables: {
      callInput: fetchInput,
    },
  });

  const { data: onEmployeeUpdate } = useSubscription(ON_EMPLOYEE_UPDATE, {
    variables: {
      dealership_id: auth?.user?.dealership_id,
    },
  });
  const userData = (app) => {
    return app.filter((user) => user.employee_user_id === auth.user.user_id);
  };

  console.log("getcallcount", data);
  console.log("onEmployeeUpdate", onEmployeeUpdate);

  useEffect(() => {
    app.setFetchData({
      d_startDate: fetchInput.d_startDate,
      d_endDate: fetchInput.d_endDate,
      f_startDate: firstOfMonth,
      f_endDate: today,
      pageCount: 0,
      rowsPerPage: 25,
      searchEmployee: "",
      searchCustomer: "",
    });
  }, []);

  const TableDataHandler = (response) => {
    let newData = response.employee.filter(
      (person) => person.employee_user_id !== auth.user.user_id,
    );
    let getActivateUser = newData.filter((person) => person.is_active);
    let managers = newData.filter((person) => person.role === "manager");
    let employees = newData.filter((person) => person.role === "employee");
    let firstData = response.employee.filter(
      (person) => person.employee_user_id === auth.user.user_id,
    );

    app.setTarget([]);
    app.setTarget([...employees, ...firstData, ...managers]);
  };

  useLayoutEffect(() => {
    if (data) {
      if (data?.getEmployeeTarget?.errors) {
        dialog({
          open: true,
          bodyType: TYPE.DEFAULT,
          body: (
            <InformationDialog
              text={data.getEmployeeTarget.errors[0].message}
            />
          ),
        });
      } else {
        TableDataHandler(data?.getEmployeeTarget);
      }
    }
  }, [data]);

  useLayoutEffect(() => {
    if (onEmployeeUpdate) {
      if (onEmployeeUpdate?.onEmployeeUpdate?.errors) {
        dialog({
          open: true,
          bodyType: TYPE.DEFAULT,
          body: (
            <InformationDialog
              text={onEmployeeUpdate.onEmployeeUpdate.errors[0].message}
            />
          ),
        });
      } else {
        TableDataHandler(onEmployeeUpdate?.onEmployeeUpdate?.employee_details);
      }
    }
  }, [onEmployeeUpdate]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      app.removeAll();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // Manager-level KPI summary, shared between the on-screen cards and the
  // PDF export triggered from ManagerComponent.
  const managerKpiData =
    app.target && app.target.length > 0
      ? getDealershipCount(app, fetchInput)
      : null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
        mt: 0,
        pt: 0,
      }}
    >
      <Box sx={HomeStyle.wrapper}>
        <Box sx={CardStyle.wrapperBox}>
          <Paper sx={CardStyle.wrapperPaper}>
            <Box sx={CardStyle.content}>
              <Box sx={CardStyle.input}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography variant="body">Hello,</Typography>
                  <Typography variant="h7" sx={HomeStyle.hello}>
                    {capitalizeFirstLetter(auth.user.first_name) +
                      " " +
                      capitalizeFirstLetter(auth.user.last_name)}
                  </Typography>
                </Box>

                <Box sx={CardStyle.iconMainBox}>
                  <Box sx={CardStyle.iconIsideBox}>
                    <IconButton
                      onClick={() => {
                        dialog({
                          open: true,
                          bodyType: TYPE.VERIFY,
                          maxWidth: "md",
                        });
                      }}
                    >
                      <RiSendPlaneFill
                        color={Theme.palette.primary.main}
                        size={30}
                      />
                    </IconButton>
                    <Typography
                      textAlign="center"
                      variant="body2"
                      sx={CardStyle.text}
                    >
                      Verification
                    </Typography>
                  </Box>
                  <Box sx={CardStyle.iconIsideBox}>
                    <IconButton
                      onClick={() => {
                        dialog({
                          open: true,
                          bodyType: TYPE.QR,
                          body: <QRCodeDialog />,
                        });
                      }}
                    >
                      <QrCode
                        sx={{ color: Theme.palette.primary.main, fontSize: 32 }}
                      />
                    </IconButton>
                    <Typography
                      textAlign="center"
                      variant="body2"
                      sx={CardStyle.text}
                    >
                      QR Code
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Divider orientation="vertical" sx={{ m: "5px" }} />
            <Box sx={CardStyle.content}>
              <Box sx={CardStyle.input}>
<Typography
  textAlign="center"
  sx={{
    ...CardStyle.textInside,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  }}
>
  {app.target && app.target.length > 0
    ? auth.user.loggedInAs === "manager"
      ? managerKpiData?.completed
      : userData(app.target)[0]?.completed
    : 0}

  {/* NEW: Insurance Verified "(+value)" — count of re-verifications
      (verification_repull rows) within the selected date range. */}
  <Box
    component="span"
    sx={{
       color: Theme.palette.primary.main,
      fontSize: "0.65em",
      fontWeight: 600,
    }}
  >
    (+
    {app.target && app.target.length > 0
      ? auth.user.loggedInAs === "manager"
        ? managerKpiData?.verified_followup ?? 0
        : userData(app.target)[0]?.verified_followup ?? 0
      : 0}
    )
  </Box>
</Typography>
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={CardStyle.text}
                >
                  Insurance Verified
                </Typography>
                {(auth.user.loggedInAs === "manager" ||
                  auth.user.loggedInAs === "employee") && (
                  <>
<Typography
  textAlign="center"
  sx={{
    ...CardStyle.textInside,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  }}
>
  {app.target && app.target.length > 0
    ? auth.user.loggedInAs === "manager"
      ? managerKpiData?.review_provided ?? 0
      : userData(app.target)[0]?.review_provided || 0
    : 0}

  {/* NEW: Reviews Provided "(+value)" — is_followup_review rows only.
      Already included in the total shown on the left
      (total = isReview rows + is_followup_review rows). */}
  <Box
    component="span"
    sx={{
      color: Theme.palette.primary.main,
      fontSize: "0.65em",
      fontWeight: 600,
    }}
  >
    (+
    {app.target && app.target.length > 0
      ? auth.user.loggedInAs === "manager"
        ? managerKpiData?.review_followup ?? 0
        : userData(app.target)[0]?.review_followup ?? 0
      : 0}
    )
  </Box>
</Typography>
                    <Typography
                      textAlign="center"
                      variant="body2"
                      sx={CardStyle.text}
                    >
                      Reviews Provided
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
          </Paper>
        </Box>

        <CardComponent
          leftLabel={`Knowledge Hub Run`}
          leftDisabled={!checkService?.knowledgeHub}
          leftValue={
            app.target && app.target.length > 0 && checkService?.knowledgeHub
              ? auth.user.loggedInAs === "manager"
                ? managerKpiData?.watchedArtifacs
                : userData(app.target)[0]?.watched_artifacts
              : 0
          }
leftText={
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 1,
    }}
  >
    <Box component="span">
      <Box
        component="span"
        sx={{
          fontSize: "0.65em",
          fontWeight: 600,
          mr: 0.3,
        }}
      >
        D:
      </Box>
<Box
  component="span"
  sx={{
    fontSize: "0.75em",
  }}
>
  {auth.user.loggedInAs === "manager" ? (
    <>
      {managerKpiData?.satisfied_yes ?? 0}
      <Box
        component="span"
        sx={{
          color: Theme.palette.error.main,
          fontWeight: 600,
        }}
      >
        /{managerKpiData?.satisfied_no ?? 0}
      </Box>
    </>
  ) : (
    <>
      {userData(app.target)[0]?.satisfied_yes ?? 0}
      <Box
        component="span"
        sx={{
          color: Theme.palette.error.main,
          fontWeight: 600,
        }}
      >
        /{userData(app.target)[0]?.satisfied_no ?? 0}
      </Box>
    </>
  )}
</Box>
    </Box>

    <Box component="span">
      <Box
        component="span"
        sx={{
          fontSize: "0.65em",
          fontWeight: 600,
          mr: 0.3,
        }}
      >
        F:
      </Box>
 <Box
  component="span"
  sx={{
    fontSize: "0.75em",
  }}
>
  {auth.user.loggedInAs === "manager" ? (
    <>
      {managerKpiData?.satisfied_yes_followup ?? 0}
      <Box
        component="span"
        sx={{
          color: Theme.palette.error.main,
          fontWeight: 600,
        }}
      >
        /{managerKpiData?.satisfied_no_followup ?? 0}
      </Box>
    </>
  ) : (
    <>
      {userData(app.target)[0]?.satisfied_yes_followup ?? 0}
      <Box
        component="span"
        sx={{
          color: Theme.palette.error.main,
          fontWeight: 600,
        }}
      >
        /{userData(app.target)[0]?.satisfied_no_followup ?? 0}
      </Box>
    </>
  )}
</Box>
    </Box>
  </Box>
}
          leftContent={`Satisfied (Y/N)`}
          rightLabel={`ID Verified (P/F)`}
          rightDisabled={!checkService?.idVerfication}
          rightValue={
    <Typography sx={CardStyle.textInside} textAlign="center">
      0
      <Box
        component="span"
        sx={{
          color: Theme.palette.error.main,
          fontSize: "0.95em",
          fontWeight: 600,
          ml: 0.5,
        }}
      >
        / 0
      </Box>
    </Typography>
  }
rightText={
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.5,
    }}
  >
    <Box component="span">
      {app.target && app.target.length > 0
        ? auth.user.loggedInAs === "manager"
          ? managerKpiData?.appointment_set
          : Math.round(userData(app.target)[0]?.appointment_set)
        : 0}
    </Box>

    {/* NEW: 1st Service Set "(+value)" — count of service_maintenance_vehicle
        rows created via the follow-up scheduling link (submitServiceFollowup). */}
    <Box
      component="span"
      sx={{
        color: Theme.palette.primary.main,
        fontSize: "0.65em",
        fontWeight: 600,
      }}
    >
      (+
      {app.target && app.target.length > 0
        ? auth.user.loggedInAs === "manager"
          ? managerKpiData?.appointment_followup ?? 0
          : userData(app.target)[0]?.appointment_followup ?? 0
        : 0}
      )
    </Box>
  </Box>
}
          rightContent={`1st Service Set`}
        />

        <CardComponent
          leftLabel={`PreQual Run`}
          leftDisabled={!checkService?.prequal}
          leftValue={0}
leftText={
  <Typography
    sx={CardStyle.textInside}
    textAlign="center"
  >
    {app.target && app.target.length > 0
      ? auth.user.loggedInAs === "manager"
        ? managerKpiData?.referral_provided
        : userData(app.target)[0]?.referral_provided
      : 0}

    {/* NEW: Referrals Provided "(+value)" — count of referral_response rows
        with is_followup = true (submitted via the follow-up referral link). */}
    <Box
      component="span"
      sx={{
        color: Theme.palette.primary.main,
        fontSize: "0.65em",
        fontWeight: 600,
        ml: 0.5,
      }}
    >
      (+
      {app.target && app.target.length > 0
        ? auth.user.loggedInAs === "manager"
          ? managerKpiData?.referral_followup ?? 0
          : userData(app.target)[0]?.referral_followup ?? 0
        : 0}
      )
    </Box>
  </Typography>
}
          leftContent={`Referrals Provided`}
          rightLabel={`Quotes Requested`}
          rightValue={
            app?.target && app?.target?.length > 0
              ? auth?.user?.loggedInAs === "manager"
                ? managerKpiData?.quotesRequested
                : userData(app?.target)[0]?.quotes_requested
              : 0
          }
          rightText={
            app.target && app.target.length > 0
              ? auth.user.loggedInAs === "manager"
                ? managerKpiData?.apps_downloaded
                : userData(app.target)[0]?.apps_downloaded
              : 0
          }
          rightContent={`Apps Downloaded`}
        />
      </Box>
      {auth.user.loggedInAs === "manager" ? (
        <ManagerComponent
          filterData={filterData}
          fetchInput={fetchInput}
          setFetchInput={setFetchInput}
          setFilterData={setFilterData}
          checkService={checkService}
          kpiData={managerKpiData}
        />
      ) : (
        <CustomersListComponent showBreadcrumbs={false} />
      )}
    </Box>
  );
};

export default HocPopup(HomeComponent);